import React from 'react';
import ProductionDataGDDKOperations from './ProductionDataGDDKOperations';
import ConsumptionDataGDDKOperations from './ConsumptionDataGDDKOperations';
import { Switch, Route, Redirect } from 'react-router';
import { NavLink } from 'react-router-dom';

const GDDKOperations = ({ t, match }) => {
  return (
    <>
      <h5 className='km__u--text-has-emphasis'>
        {t('pages.default.gddkOperations.title')}
      </h5>

      <ul className='km__p--gddk-tab-list'>
        <li>
          <NavLink
            className='km__u--text_title'
            to={`${match.url}/production-data`}
            activeClassName='km__p--gddk-tab-active'
          >
            {t('pages.default.gddkOperations.productionDataTitle')}
          </NavLink>
        </li>
        <li>
          <NavLink
            className='km__u--text_title'
            to={`${match.url}/consumption-data`}
            activeClassName='km__p--gddk-tab-active'
          >
            {t('pages.default.gddkOperations.consumptionDataTitle')}
          </NavLink>
        </li>
      </ul>

      <Switch>
        <Route
          path={`${match.url}/production-data`}
          render={(props) => <ProductionDataGDDKOperations t={t} {...props} />}
        />
        <Route
          path={`${match.url}/consumption-data`}
          render={(props) => <ConsumptionDataGDDKOperations t={t} {...props} />}
        />
        <Redirect to={`${match.url}/production-data`} />
      </Switch>
    </>
  );
};

export default GDDKOperations;
